

import React from "react";
import Header from "../../_components/header/header";
import Footer from "../../_components/footer/footer";
import { Container } from "reactstrap";
import graphQLRequestGlobal from "../../services/graphQlRequestGlobal";
import sitePages from "../../services/Queries/sitePages/sitePages";
import { getValue } from "../../utils/lodash";
import Row from "reactstrap/lib/Row";
import Col from "reactstrap/lib/Col";
// import showdown from "showdown";

class CancellationPolicy extends React.Component {
  constructor(props, context) {
    super(props, context);
    this.state = {
      siteInfo: [],
    };
  }

  componentDidMount() {
    window.scroll({ top: 0, behavior: "smooth" });
    this.getInfo();
  }
  getInfo = async () => {
    let resp = await graphQLRequestGlobal(sitePages);
    this.setState({
      siteInfo: resp.sitePages.filter((item) => item.slug === "cancellation-policy"),
    });
  };

  render() {
    // var converter = new showdown.Converter();
    return (
      <>
        <Container fluid={true}>
          <Row className="faq-page page-policy">
            <Col md={{ size: "8", offset: "2" }}>
              <h2 className="home-heading mt-md-5 mt-3 mb-4">Cancellation Policy</h2>
              {getValue(this.state, "siteInfo", "").map((item) => {
                return (
                  <div
                    className="abtcnt"
                    style={{ whiteSpace: "pre-line" }}
                    dangerouslySetInnerHTML={{
                      __html: getValue(item, "content", ""),
                      // __html: converter.makeHtml(getValue(item, "content", "")),
                    }}
                  />
                );
              })}
            </Col>
          </Row>
        </Container>
      </>
    );
  }
}
export default CancellationPolicy;
